import { Box, CircularProgress, styled } from '@mui/material';
import { StatusType } from './types';

const Dot = styled(Box)(({ theme }) => ({
  width: theme.spacing(1),
  height: theme.spacing(1),
  position: 'relative',

  '&:after': {
    content: '""',
    display: 'block',
    width: theme.spacing(0.75),
    height: theme.spacing(0.75),
    borderRadius: '100%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: theme.palette.text.disabled,
  },

  '&.success': {
    '&:after': {
      backgroundColor: theme.palette.success.main,
    },
  },

  '&.primary': {
    '&:after': {
      backgroundColor: theme.palette.primary.main,
    },
  },

  '&.error': {
    '&:after': {
      backgroundColor: theme.palette.error.main,
    },
  },

  '&.warning': {
    '&:after': {
      backgroundColor: theme.palette.warning.main,
    },
  },
}));

export default function StatusDot({ type }: { type?: StatusType }) {
  switch (type) {
    case StatusType.IsPrimary:
      return <Dot className="primary" />;
    case StatusType.IsSuccess:
      return <Dot className="success" />;
    case StatusType.IsError:
      return <Dot className="error" />;
    case StatusType.IsWarning:
      return <Dot className="warning" />;
    case StatusType.IsPending:
      return <CircularProgress size="8px" />;
    default:
      return <Dot />;
  }
}
